import supportModule from '../../support.module';

export default supportModule.component('supportFeedEvent', {
    template: require('./supportFeedEvent.component.html'),
    styles: require('./supportFeedEvent.component.css'),
    controller: controller,
    bindings: {
        event: '<'
    }
});

function controller(stringHelper) {
    var vm = this;

    vm.unescape = () => {
        if (vm.event && vm.event.body) {
            return stringHelper.unescape(vm.event.body);
        }
    };
}



// WEBPACK FOOTER //
// ./modules/support/components/support-feed-event/supportFeedEvent.component.js